import { instance } from '@/api'
import { createBaseApi } from '@/api/baseApi'
import { createFileApi } from '@/api/baseFileApi'

const CERTIFICATE_URL = 'warehouse/w-certificates'

export default {
  ...createBaseApi(CERTIFICATE_URL),
  ...createFileApi(CERTIFICATE_URL),

  /*
  * Добавление файлов для сертификата
  * */
  addFilesCertificate: async (id, data) => {
    return await instance.postForm(`/${CERTIFICATE_URL}/${id}/upload`, data)
  },

  /*
  * Замена файла сертификата
  * */
  changeFile: async (id, data) => {
    return await instance.postForm(`/${CERTIFICATE_URL}/${id}/change-file`, data)
  },

  /*
  * Редактирование сертификата (name и d_wires)
  * */
  update: async (data) => {
    return await instance.put(`/${CERTIFICATE_URL}`, data)
  },

  /*
  * Удаление сертификата (name и d_wires)
  * */
  delete: async (params) => {
    return await instance.delete(`/${CERTIFICATE_URL}`, { params })
  }
}
